export default __webpack_public_path__ + "static/media/level4.5bf390c0.png";